<section class="app-shell">
    <side-nav-sidebar></side-nav-sidebar>

    <main class="app-content">
        <router-outlet></router-outlet>
    </main>
</section>
